import { axiosClient } from '../../clients/axios-client'

export async function uploadFileToS3({ file, uploadUrl }: { file: File; uploadUrl: string }) {
  try {
    const res = await axiosClient.put(uploadUrl, file, {
      headers: {
        'Content-Type': file.type,
      },
      timeout: 60000,
      transformRequest: [
        (data, headers) => {
          delete headers.Authorization
          return data
        },
      ],
    })
    if (res.status !== 200) {
      throw new Error('File upload to S3 failed')
    }

    return { success: true }
  } catch (error) {
    console.error(
      `File upload failed. File name: ${file.name}, file size: ${file.size}, file type: ${file.type}`,
      error
    )
    throw error
  }
}
